/* eslint-disable camelcase */
import { EventsService } from '@common/ApiService'

const CREATE_SUCCESS = 'CREATE_SUCCESS'
const ERROR = 'ERROR'
const INDEX_SUCCESS = 'INDEX_SUCCESS'
const SHOW_SUCCESS = 'SHOW_SUCCESS'
const UPDATE_SUCCESS = 'UPDATE_SUCCESS'

export const state = {
  event: {},
  events: [],
}

export const getters = {
  eventsCount(state) {
    return state.events.length
  },
}

export const mutations = {
  [CREATE_SUCCESS](state, data) {
    state.event = data
  },
  [ERROR](state, data) {
    state.error = data
  },
  [INDEX_SUCCESS](state, data) {
    state.events = data
  },
  [SHOW_SUCCESS](state, data) {
    state.event = data
  },
  [UPDATE_SUCCESS](state, data) {
    state.event = data
  },
}

const getRecipient = (event) => {
  const { passenger_notification, staff_notification } = event

  switch (true) {
    case staff_notification && passenger_notification:
      return 'All'
    case !staff_notification && passenger_notification:
      return 'Passenger'
    case staff_notification && !passenger_notification:
      return 'Staff'
    default:
      return 'None'
  }
}

const getEventStatus = (event) => {
  const todayDate = Date.parse(new Date().toISOString().slice(0, 10))
  const startDate = Date.parse(event.start_date)
  const endDate = Date.parse(event.end_date)

  switch (true) {
    case todayDate < startDate:
      return 'upcoming'
    case startDate <= todayDate && todayDate <= endDate:
      return 'in_progress'
    default:
      return 'closed'
  }
}

export const actions = {
  create({ commit }, params) {
    return EventsService.create(params)
      .then((response) => {
        commit(CREATE_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error)
        return error.response.data
      })
  },
  destroy({ commit }, id) {
    return EventsService.destroy(id)
      .then(() => {
        return { success: 'Event deleted' }
      })
      .catch((error) => {
        commit(ERROR, error)
        return error.response.data
      })
  },
  get({ commit }, id) {
    return EventsService.get(id)
      .then((response) => {
        const status = getEventStatus(response.data)
        const event = { ...response.data, status }
        commit(SHOW_SUCCESS, event)
        return event
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  index({ commit }, params) {
    return EventsService.index(params)
      .then((response) => {
        let eventData = response.data.map((event) => {
          let recipients = getRecipient(event)
          let status = getEventStatus(event)
          return { ...event, recipients, status }
        })
        commit(INDEX_SUCCESS, eventData)
        return eventData
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  update({ commit }, params) {
    return EventsService.update(params.id, params)
      .then((response) => {
        const status = getEventStatus(response.data)
        const event = { ...response.data, status }
        commit(UPDATE_SUCCESS, event)
        return event
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
}
